import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import AlarmIcon from '@material-ui/icons/Alarm';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(to bottom, #ffffff, #f0f0f0)',
    },
    form: {
      width: '50%',
      maxWidth: 400,
      padding: theme.spacing(3),
      background: '#fff',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    textField: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    button: {
      width: '100%',
    },
  }),
);

interface IProps {
  onCompleted: (isCompleted: boolean) => void;
}

export const AlarmClockCard: React.FC<IProps> = ({onCompleted}) => {

  const classes = useStyles();
  const [isAlarmSetCompleted, setIsAlarmSetCompleted] = React.useState(false);
  const handleSetAlarm = () => {
    setIsAlarmSetCompleted(true);
  };

  React.useEffect(()=>{
    onCompleted(isAlarmSetCompleted);
  },[isAlarmSetCompleted]);

  return (
    <div className={classes.container}>
      <form className={classes.form} noValidate>
      {isAlarmSetCompleted?<CheckCircleIcon color='primary' style={{fontSize: 64, marginBottom: 16}}/>: <AlarmIcon color="primary" style={{fontSize: 64, marginBottom: 16}}/>}
        <TextField
          id="time"
          label="Set Alarm Time"
          type="time"
          defaultValue="07:30"
          className={classes.textField}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 300,
          }}
        />
        
        <Button variant="contained" color="primary" className={classes.button} onClick={handleSetAlarm}>
          <Typography>Set Alarm</Typography>
        </Button>
      </form>
    </div>
  );
};